import { CardMedia, Collapse, Grid, Typography } from "@mui/material";
import { Box } from "@mui/system";
import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { useNavSection } from "./hooks/useNavSection";

// Reusable menu item component
const NavMenuItem = ({
  to,
  label,
  icon,
  activeIcon,
  active,
  onClick,
  sx = {},
}) => (
  <NavLink to={to} style={{ textDecoration: "none" }}>
    <Box
      className="flex items-center m-auto mt-1 w-[13.5rem] h-[3.3rem]"
      sx={{
        boxShadow: active ? "0px 11px 21px 0px rgba(0,0,0,0.1)" : "",
        borderRadius: 2,
        backgroundColor: active ? "white" : "",
        "&:hover": {
          color: "white",
          backgroundColor: "RGB(225 222 229)",
        },
        ...sx,
      }}
      onClick={onClick}
    >
      <Box
        className="dashboard-icon-shadow"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: "32px",
          height: "32px",
          ml: "20px",
          backgroundColor: active ? "RGB(124 140 170)" : "white",
        }}
      >
        <CardMedia
          component="img"
          sx={{ height: 15, width: 15 }}
          image={active ? activeIcon : icon}
          alt={label}
        />
      </Box>
      <Typography
        component="div"
        ml="10px"
        lineHeight="22px"
        fontStyle="Open Sans"
        color="#67748E"
        fontSize="14px"
        fontWeight={active ? "bold" : ""}
      >
        {label}
      </Typography>
    </Box>
  </NavLink>
);

const menuConfig = [
  {
    to: "/dashboard",
    label: "Dashboard",
    icon: "../images/home.svg",
    activeIcon: "../images/homeWhite.svg",
    section: "main",
  },
  {
    to: "/transaction",
    label: "Transaction",
    icon: "../images/block.svg",
    activeIcon: "../images/blockWhite.svg",
    section: "reports",
  },
  {
    to: "/cashcollect",
    label: "Collection",
    icon: "../images/block.svg",
    activeIcon: "../images/blockWhite.svg",
    section: "reports",
  },
  {
    to: "/settlement-report",
    label: "Settlement",
    icon: "../images/block.svg",
    activeIcon: "../images/blockWhite.svg",
    section: "reports",
  },
  {
    to: "/complimentary-details",
    label: "Compliments",
    icon: "../images/block.svg",
    activeIcon: "../images/blockWhite.svg",
    section: "reports",
  },
  {
    to: "/attendence",
    label: "Attendance",
    icon: "../images/block.svg",
    activeIcon: "../images/blockWhite.svg",
    section: "reports",
  },
  {
    to: "/parking-type",
    label: "Parking Type",
    icon: "../images/block.svg",
    activeIcon: "../images/blockWhite.svg",
    section: "reports",
  },
  {
    to: "/shiftmaster",
    label: "Shift Management",
    icon: "../images/slot.svg",
    activeIcon: "../images/slotWhite.svg",
    section: "masters",
    collapse: true,
  },
  {
    to: "/shiftmaster/assign",
    label: "Assign",
    icon: "../images/slot.svg",
    activeIcon: "../images/slotWhite.svg",
    section: "masters",
    collapseChild: true,
  },
  {
    to: "/staffonboarding",
    label: "Staff Management",
    icon: "../images/slot.svg",
    activeIcon: "../images/slotWhite.svg",
    section: "masters",
  },
  {
    to: "/vehicle",
    label: "Vehicle",
    icon: "../images/block.svg",
    activeIcon: "../images/blockWhite.svg",
    section: "masters",
  },
  {
    to: "/parkingtype",
    label: "Parking Type",
    icon: "../images/block.svg",
    activeIcon: "../images/blockWhite.svg",
    section: "masters",
  },
  {
    to: "/fee",
    label: "Fee",
    icon: "../images/block.svg",
    activeIcon: "../images/blockWhite.svg",
    section: "masters",
  },
  {
    to: "/paymentmode",
    label: "Payment Mode",
    icon: "../images/floor.svg",
    activeIcon: "../images/floorWhite.svg",
    section: "masters",
  },
  {
    to: "/entrybooth",
    label: "Gates",
    icon: "../images/slot.svg",
    activeIcon: "../images/slotWhite.svg",
    section: "masters",
  },
  {
    to: "/location-master",
    label: "Location",
    icon: "../images/block.svg",
    activeIcon: "../images/blockWhite.svg",
    section: "masters",
  },
  {
    to: "/area",
    label: "Area",
    icon: "../images/floor.svg",
    activeIcon: "../images/floorWhite.svg",
    section: "masters",
  },
  // {
  //   to: "/block",
  //   label: "Block",
  //   icon: "../images/block.svg",
  //   activeIcon: "../images/blockWhite.svg",
  //   section: "masters",
  // },
  {
    to: "/floor",
    label: "Floor",
    icon: "../images/floor.svg",
    activeIcon: "../images/floorWhite.svg",
    section: "masters",
  },
  {
    to: "/slot",
    label: "Slot",
    icon: "../images/slot.svg",
    activeIcon: "../images/slotWhite.svg",
    section: "masters",
  },
  {
    to: "/slotcount",
    label: "Slot Count",
    icon: "../images/slot.svg",
    activeIcon: "../images/slotWhite.svg",
    section: "masters",
    collapse: true,
  },
  {
    to: "/extra-charges",
    label: "Extra Charges",
    icon: "../images/slot.svg",
    activeIcon: "../images/slotWhite.svg",
    section: "masters",
  },
  {
    to: "/profile-settings",
    label: "Profile settings",
    icon: "../images/slot.svg",
    activeIcon: "../images/slotWhite.svg",
    section: "settings",
  },
];

const allowedPaths = {
  ADMIN: [
    "/dashboard",
    "/transaction",
    "/cashcollect",
    "/settlement-report",
    "/complimentary-details",
    "/parking-type",
    // "/shiftmaster",
    // "/shiftmaster/assign",
    "/staffonboarding",
    "/vehicle",
    "/parkingtype",
    "/fee",
    "/paymentmode",
    "/entrybooth",
    "/location-master",
    "/area",
    "/block",
    "/floor",
    "/slot",
    "/slotcount",
    "/extra-charges",
    // "/profile-settings",
  ],
  SUPERVISOR: [
    "/dashboard",
    "/transaction",
    "/cashcollect",
    "/settlement-report",
    "/complimentary-details",
    "/parking-type",
    // "/profile-settings",
  ],
  USER: [
    "/dashboard",
    // "/profile-settings"
  ],
};

const NavSection = () => {
  const { shiftManagementCollapse, setShiftManagementCollapse } =
    useNavSection();
  const location = useLocation();
  const userType = localStorage.getItem("userType");

  // Filter menu items based on allowed paths for userType
  const filteredMenu = menuConfig.filter((item) =>
    allowedPaths[userType]?.includes(item.to)
  );

  // Group menu items by section
  const mainMenu = filteredMenu.filter((item) => item.section === "main");
  const reportsMenu = filteredMenu.filter((item) => item.section === "reports");
  const mastersMenu = filteredMenu.filter(
    (item) => item.section === "masters" && !item.collapseChild
  );
  const mastersCollapseMenu = filteredMenu.filter((item) => item.collapseChild);
  const settingsMenu = filteredMenu.filter(
    (item) => item.section === "settings"
  );

  return (
    <Box sx={{ width: "100%", height: "100%", mb: 2, mt: 1 }}>
      <Grid>
        {/* Main Section */}
        {mainMenu.map((item) => (
          <NavMenuItem
            key={item.to}
            {...item}
            active={location.pathname === item.to}
          />
        ))}

        {/* Reports Section */}
        {reportsMenu.length > 0 && (
          <>
            <Typography
              sx={{
                mt: 3,
                ml: 3,
                fontWeight: 700,
                fontSize: 12,
                fontFamily: "Open Sans",
                opacity: "60%",
                color: "rgba(52, 71, 103, 1)",
              }}
            >
              REPORTS
            </Typography>
            {reportsMenu.map((item) => (
              <NavMenuItem
                key={item.to}
                {...item}
                active={location.pathname === item.to}
              />
            ))}
          </>
        )}

        {/* Masters Section */}
        {mastersMenu.length > 0 && (
          <>
            <Typography
              sx={{
                mt: 2,
                ml: 3,
                fontWeight: 700,
                fontSize: 12,
                fontFamily: "Open Sans",
                opacity: "60%",
                color: "rgba(52, 71, 103, 1)",
              }}
            >
              MASTERS
            </Typography>
            {mastersMenu.map((item) =>
              item.collapse ? (
                <React.Fragment key={item.to}>
                  <NavMenuItem
                    {...item}
                    active={location.pathname === item.to}
                    onClick={() =>
                      setShiftManagementCollapse(!shiftManagementCollapse)
                    }
                  />
                  <Collapse
                    className="collapse-link"
                    in={shiftManagementCollapse}
                  >
                    {mastersCollapseMenu.length > 0 &&
                      mastersCollapseMenu.map((child) => (
                        <Box className="ml-[18%] mt-3" key={child.to}>
                          <NavMenuItem
                            {...child}
                            active={location.pathname === child.to}
                          />
                        </Box>
                      ))}
                  </Collapse>
                </React.Fragment>
              ) : (
                <NavMenuItem
                  key={item.to}
                  {...item}
                  active={location.pathname === item.to}
                />
              )
            )}
          </>
        )}

        {/* Divider */}
        {/* {settingsMenu.length > 0 && (
          <Divider
            variant="middle"
            className="bg-gradient-to-r from-[rgba(0, 0, 0, 0.4)] to-[rgba(0, 0, 0, 0)] h-[1px]"
          />
        )} */}

        {/* Settings Section */}
        {/* {settingsMenu.length > 0 && (
          <>
            <Typography
              sx={{
                mt: 2,
                ml: 3,
                fontWeight: 700,
                fontSize: 12,
                fontFamily: "Open Sans",
                opacity: "60%",
                color: "rgba(52, 71, 103, 1)",
              }}
            >
              SETTINGS
            </Typography>
            {settingsMenu.map((item) => (
              <NavMenuItem
                key={item.to}
                {...item}
                active={location.pathname === item.to}
              />
            ))}
          </>
        )} */}
      </Grid>
    </Box>
  );
};

export default NavSection;
